var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-7 col-s-12",staticStyle:{"background-color":"white","padding":"0","margin":"0"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"mt-2"}),_c(_vm.getActiveContent,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }